<template>
  <modal name="contract-details-modal"
         @closed="$emit('updateComparisonData')"
         @before-open="beforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Պայմանագրի մանրամասներ</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('contract-details-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4 pb-0" style="overflow-x: auto; height: 95%">
      <table class="VueTables__table table table-striped table-bordered table-hover" style="overflow: hidden;">
        <thead>
            <tr>
              <th tabindex="0" title="" class="VueTables__sortable " style="position: relative;">
                  <div class="row justify-content-center">
                    <span class="VueTables__heading">Պայմանագրի ծածկագիր</span>
                  </div>
                  <div class="resize-handle" style="top: 0px; right: 0px; width: 5px; position: absolute; cursor: col-resize; user-select: none; height: 92px;"></div>
              </th>
              <th tabindex="0" title="" class="VueTables__sortable ">
                  <div class="row justify-content-center">
                    <span class="VueTables__heading">Պատվիրատու</span>
                  </div>
              </th>
              <!-- <th tabindex="0" title="" class="VueTables__sortable ">
                  <div class="row justify-content-center">
                    <span class="VueTables__heading">Հեռախոս</span>
                  </div>
              </th>
              <th tabindex="0" title="" class="VueTables__sortable ">
                  <div class="row justify-content-center">
                    <span class="VueTables__heading">Էլ. փոստ</span>
                  </div>
              </th> -->
            </tr>
        </thead>
        <tbody>
            <tr class="VueTables__row ">
              <td tabindex="0" class="">{{contract.code && contract.code}}</td>
              <td tabindex="0" class="">{{contract.client && contract.client.name}}</td>
              <!-- <td tabindex="0" class="">{{contract.client && contract.client.phone}}</td> -->
              <!-- <td tabindex="0" class="">{{contract.client && contract.client.email}}</td> -->
            </tr>
        </tbody>
      </table>

      <div class="table-responsive">
      <v-client-table ref="vtable" :columns="columns" v-model="contract.lots" :options="options">
        <div slot="index" class="more d-flex justify-content-center" slot-scope="{row, index}">
          {{index}}
        </div>
        <div slot="id" slot-scope="{row}">
          {{ row.view_id }}
        </div>
        <div slot="cpv_name" slot-scope="{row}">
          {{row.name}}
        </div>
        <div slot="specification" slot-scope="{row}">
          {{row.specification}}
        </div>
        <div slot="unit" slot-scope="{row}">
          {{row.unit}}
        </div>
        <div slot="purchase_schedule" slot-scope="{row}">
          {{row.delivery_date}}
        </div>
        <div slot="unit_price" slot-scope="{row}">
          {{row.price_unit}}դր.
        </div>
        <div slot="total_price" slot-scope="{row}">
          {{row.price}}դր.
        </div>
        <div slot="count" slot-scope="{row}">
          {{row.available + row.ordered + row.supplied}}
        </div>
        <div slot="leftover" slot-scope="{row}">
          {{row.available}}
        </div>
      </v-client-table>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'ContractDetailsModal',
  data () {
    return {
      isSetEqual: false,
      isSuccess: true,
      lotsWithError: [],
      columns: ['index', 'cpv_name', 'specification', 'unit', 'purchase_schedule', 'unit_price', 'total_price', 'count', 'leftover'],
      contract: {},
      lots: [],
      index: 0,
      focusedLotFields: {},
      lotsWithVatLength: 0,
      sugesstion: {},
      options: {
        sortable: [],
        perPage: 1000,
        perPageValues: [],
        columnsDropdown: false,
        filterByColumn: false,
        dateFormat: "YYYY-mm-dd",
        headings: {
          id: 'Չ/Հ',
          index: '№',
          cpv_name: 'անվանում',
          specification: 'Բնութագիր',
          unit: 'Չափման միավորը',
          purchase_schedule: 'Մատակարարման ժամկետ',
          unit_price: 'Միավորի գինը',
          total_price: 'Ընդհանուր գինը',
          count: 'Ընդհանուր Քանակը',
          leftover: 'Մնացորդ',
          order_input: 'Պատվիրել',
          order_price: 'Պատվերի Գումարը',
        },
        filterable: false
      },
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    consoleLog(data){
      console.log(data)
    },
    beforeOpen({params}) {
      this.resetComponent = params.resetComponent
      this.contract = params
    },
  }
}
</script>
<style scoped>

</style>
<style scoped>
  /deep/ .page-item {
      display: none;
  }
  /deep/ .vm--modal {
    top: 3rem !important;
    left: unset !important;
    width: 80% !important;
    height: 80% !important;
    margin: auto;
    padding-bottom: 70px;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
  .searchItem:hover {
    background-color: #1e7bb7;
    color: #fff;
  }
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .2s ease;
  }
  .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>

